import styled, { css } from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { ADAPTIVE } from '@yme/tokens/screen';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getAdaptiveStyles } from '@yme/utils/styles';
import { FORM_STYLE_PARAMETERS, HEIGHTS } from './constants';
export const DealerLocatorStyled = styled.div `
  position: relative;

  min-height: ${HEIGHTS.initialState.sm.height};

  ${ADAPTIVE.minWidth.tablet} {
    min-height: ${HEIGHTS.initialState.md.height};
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: ${HEIGHTS.initialState.lg.height};
  }
`;
export const ImageStyled = styled(Image) `
  transition: height 0.5s linear;

  ${({ isInitialState }) => isInitialState
    ? css `
          ${getAdaptiveStyles(HEIGHTS.initialState)}
        `
    : css `
          ${getAdaptiveStyles(HEIGHTS.withDealerCards)}
        `};

  & > picture {
    & > img {
      height: 100%;
      object-fit: cover;
      object-position: 0 50%;
    }
  }
`;
export const DealerLocatorFormStyled = styled.div `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  height: auto;
  width: 100%;

  z-index: ${Z_INDEX.level1};

  ${getAdaptiveStyles(FORM_STYLE_PARAMETERS)}
`;
export const ColStyled = styled(Col) `
  margin: 0 auto;
`;
